<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 8" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="306px" height="200px" animated />
      <shSkeleton bg="#e4e4e4" width="295px" height="40px" animated />
      <shSkeleton bg="#e4e4e4" width="120px" height="24px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 1240px;
  min-height: 613px;
  display: flex;
  flex-wrap: wrap;

  justify-content: space-between;

  .item {
    width: 306px;
    height: 306.5px;

    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 16px auto 0;
    }
  }
}
</style>
